/* AUREMAR camera capture.

   `<input capture>` is a mobile-only hint, on a laptop the browser ignores it
   and opens the file picker, which is not what "Take a photo" should do. This
   opens the webcam through getUserMedia and takes the shot on a canvas, and
   only falls back to a file input where that is not available. */
window.AuremarCamera = (function () {
  'use strict';

  var overlay = null;
  var stream = null;

  function stop() {
    if (stream) {
      stream.getTracks().forEach(function (t) { t.stop(); });
      stream = null;
    }
  }

  function close() {
    stop();
    if (overlay && overlay.parentNode) overlay.parentNode.removeChild(overlay);
    overlay = null;
    document.body.style.overflow = '';
  }

  function build() {
    overlay = document.createElement('div');
    overlay.className = 'modal-scrim';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.setAttribute('aria-label', 'Take a photo');
    overlay.innerHTML =
      '<div class="modal camera">' +
        '<div class="modal__head">' +
          '<p class="overline" style="margin:0">Take a photo</p>' +
          '<button class="modal__close" type="button" data-close aria-label="Close">&times;</button>' +
        '</div>' +
        '<div data-body></div>' +
      '</div>';
    document.body.appendChild(overlay);
    document.body.style.overflow = 'hidden';
    overlay.querySelector('[data-close]').addEventListener('click', close);
    overlay.addEventListener('click', function (e) { if (e.target === overlay) close(); });
    return overlay.querySelector('[data-body]');
  }

  function fail(body, message) {
    body.innerHTML =
      '<p class="muted" style="font-size:14px">' + message + '</p>' +
      '<div class="actions"><button class="btn" type="button" data-cancel>Close</button></div>';
    body.querySelector('[data-cancel]').addEventListener('click', close);
  }

  function open(onCapture) {
    var body = build();

    if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
      fail(body, 'This browser cannot open the camera. Upload a photo instead.');
      return;
    }

    body.innerHTML =
      '<div class="camera__stage"><video muted playsinline></video></div>' +
      '<div class="actions">' +
        '<button class="btn btn--gold" type="button" data-shoot disabled>Starting camera&hellip;</button>' +
        '<button class="btn" type="button" data-cancel>Cancel</button>' +
      '</div>';

    var video = body.querySelector('video');
    var shoot = body.querySelector('[data-shoot]');
    body.querySelector('[data-cancel]').addEventListener('click', close);

    navigator.mediaDevices
      .getUserMedia({ video: { facingMode: { ideal: 'environment' }, width: { ideal: 1920 } }, audio: false })
      .then(function (s) {
        stream = s;
        video.srcObject = s;
        return video.play();
      })
      .then(function () {
        shoot.disabled = false;
        shoot.textContent = 'Capture';
      })
      .catch(function (err) {
        fail(
          body,
          err && err.name === 'NotAllowedError'
            ? 'Camera access was blocked. Allow it in your browser settings, or upload a photo instead.'
            : 'No camera available. Upload a photo instead.'
        );
      });

    shoot.addEventListener('click', function () {
      if (!video.videoWidth) return;
      var canvas = document.createElement('canvas');
      canvas.width = video.videoWidth;
      canvas.height = video.videoHeight;
      canvas.getContext('2d').drawImage(video, 0, 0);
      canvas.toBlob(function (blob) {
        if (!blob) return;
        onCapture(new File([blob], 'room-' + Date.now() + '.jpg', { type: 'image/jpeg' }));
        close();
      }, 'image/jpeg', 0.92);
    });
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && overlay) close();
  });

  return { open: open };
})();
